import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import { getSupportPortalLinks } from '../../config/supportPortals'
import { AppDrawerItemCard, AppDrawerSection } from '../shared/AppDrawer'

interface SupportTabProps {
  country?: string | null
}

const SupportTab: React.FC<SupportTabProps> = ({ country }) => {
  const links = getSupportPortalLinks(country || 'AU')

  return (
    <Stack spacing={1.25}>
      <AppDrawerSection
        icon={<InfoOutlinedIcon sx={{ fontSize: 18, color: 'warning.main' }} />}
        title="Blocking your work today?"
        sx={{ borderColor: 'warning.light', bgcolor: '#fffaf2' }}
      >
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontSize: '0.78rem', lineHeight: 1.5 }}>
          Use the support portal for anything urgent - the Evo Support team picks it up directly.
        </Typography>
      </AppDrawerSection>

      <Stack spacing={1}>
        {links.map(link => {
          const Icon = link.Icon
          return (
            <AppDrawerItemCard
              key={link.key}
              href={link.url}
              external
              leadingIcon={<Icon sx={{ fontSize: 20 }} />}
              title={link.label}
              subtitle={link.helper}
              actions={
                <Box sx={{ display: 'flex', alignItems: 'center', mt: 0.25 }}>
                  <OpenInNewIcon
                    sx={{ fontSize: 16, color: 'text.secondary' }}
                    aria-hidden
                  />
                </Box>
              }
            />
          )
        })}
      </Stack>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mt: 1, px: 0.5, fontSize: '0.72rem' }}
      >
        Otherwise, leave feedback on the "Give feedback" tab - it's a quick note to the Evo team.
      </Typography>
    </Stack>
  )
}

export default SupportTab
